import type {
    CollectNormalizedOrganizationServiceParams,
    CollectNormalizedOrganizationServiceResult,
} from '../types';
import collectUnsupportedOrganizationService from './collectUnsupportedOrganizationService';
import normalizeOrganizationServiceFromApi from './normalizeOrganizationServiceFromApi';

const collectNormalizedOrganizationService = ({
    instance,
}: CollectNormalizedOrganizationServiceParams): CollectNormalizedOrganizationServiceResult => {
    try {
        return {
            instance: normalizeOrganizationServiceFromApi({ dto: instance }),
            unsupportedError: undefined,
        };
    } catch (caughtError) {
        return {
            instance: null,
            unsupportedError: collectUnsupportedOrganizationService({ caughtError }),
        };
    }
};

export default collectNormalizedOrganizationService;
